/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppRoutes, RouteParams } from "../constants";
import { SuperAdminGuard } from "../guards/super-admin/super-admin.guard";
import { TabsPage } from "./tabs.page";

const routes: Routes = [
  {
    path: "",
    component: TabsPage,
    children: [
      {
        path: AppRoutes.home,
        loadChildren: () => import("../pages/home/home.module").then(m => m.HomePageModule),
      },
      {
        path: AppRoutes.learningModules,
        loadChildren: () => import("../pages/learning-modules/learning-modules.module").then(m => m.LearningModulesPageModule),
      },
      {
        path: AppRoutes.reports,
        loadChildren: () => import("../pages/reports/reports.module").then(m => m.ReportsPageModule),
      },
      {
        path: AppRoutes.settings,
        loadChildren: () => import("../pages/settings/settings.module").then(m => m.SettingsPageModule),
      },
      {
        path: AppRoutes.webBuilder,
        loadChildren: () => import("../pages/web-builder/web-builder.module").then(m => m.WebBuilderPageModule),
      },
      {
        path: `${AppRoutes.webBuilder}/:path`,
        loadChildren: () => import("../pages/web-builder/web-builder.module").then(m => m.WebBuilderPageModule),
      },
      {
        path: AppRoutes.helloCash,
        loadChildren: () => import("../pages/hello-cash/hello-cash.module").then(m => m.HelloCashPageModule),
      },
      {
        path: AppRoutes.registerPOS,
        loadChildren: () => import("../pages/register-pos/register-pos.module").then(m => m.RegisterPOSPageModule),
      },
      {
        path: AppRoutes.helpCenter,
        loadChildren: () => import("../pages/help-center/help-center.module").then(m => m.HelpCenterPageModule),
      },
      {
        path: AppRoutes.askQuestion,
        loadChildren: () => import("../pages/ask-question/ask-question.module").then(m => m.AskQuestionPageModule),
      },
      {
        path: AppRoutes.welcome,
        loadChildren: () => import("../pages/welcome/welcome.module").then(m => m.WelcomePageModule),
      },
      {
        path: AppRoutes.notifications,
        loadChildren: () => import("../pages/notifications/notifications.module").then(m => m.NotificationsPageModule),
      },
      {
        path: AppRoutes.events,
        loadChildren: () => import("../pages/events/events.module").then(m => m.EventsPageModule),
      },
      {
        path: `${AppRoutes.events}/:${RouteParams.eventId}`,
        loadChildren: () => import("../pages/event-detail/event-detail.module").then(m => m.EventDetailPageModule),
      },
      {
        path: AppRoutes.eventContents,
        loadChildren: () => import("../pages/event-contents/event-contents.module").then(m => m.EventContentsPageModule),
        canActivate: [SuperAdminGuard],
      },
      {
        path: AppRoutes.successReport,
        loadChildren: () => import("../pages/success-report/success-report.module").then(m => m.SuccessReportPageModule),
      },
      {
        path: AppRoutes.bwaReport,
        loadChildren: () => import("../pages/bwa-report/bwa-report.module").then(m => m.BWAReportPageModule),
      },
      {
        path: AppRoutes.bookCheckUp,
        loadChildren: () => import("../pages/book-check-up/book-check-up.module").then(m => m.BookCheckUpPageModule),
      },
      {
        path: AppRoutes.postponeCheckUp,
        loadChildren: () => import("../pages/postpone-check-up/postpone-check-up.module").then(m => m.PostponeCheckUpPageModule),
      },
      {
        path: AppRoutes.kajabi,
        loadChildren: () => import("../pages/kajabi/kajabi.module").then(m => m.KajabiPageModule),
      },
      {
        path: AppRoutes.domainAddress,
        loadChildren: () => import("../pages/domain-address/domain-address.module").then(m => m.DomainAddressPageModule),
      },
      {
        path: AppRoutes.challengeOnboarding,
        loadChildren: () => import("../pages/challenge-onboarding/challenge-onboarding.module").then(m => m.ChallengeOnboardingPageModule),
      },
      {
        path: AppRoutes.scenarios,
        loadChildren: () => import("../pages/scenarios/scenarios.module").then(m => m.ScenariosPageModule),
      },
      {
        path: `${AppRoutes.scenarios}/:${RouteParams.scenarioId}`,
        loadChildren: () => import("../pages/scenario/scenario.module").then(m => m.ScenarioPageModule),
      },
      {
        path: AppRoutes.success,
        loadChildren: () => import("../pages/success/success.module").then(m => m.SuccessPageModule),
      },
      {
        path: AppRoutes.integrations,
        loadChildren: () => import("../pages/integrations/integrations.module").then(m => m.IntegrationsPageModule),
      },
      {
        path: AppRoutes.adminModules,
        loadChildren: () => import("../pages/admin-modules/admin-modules.module").then(m => m.AdminModulesPageModule),
        canActivate: [SuperAdminGuard],
      },
      {
        path: AppRoutes.adminSurveyDefinitions,
        loadChildren: () => import("../pages/admin-surveys/admin-survey-definitions.module").then(m => m.AdminSurveyDefinitionsPageModule),
        canActivate: [SuperAdminGuard],
      },
      {
        path: "",
        redirectTo: `/${AppRoutes.home}`,
        pathMatch: "full",
      },
    ],
  },
  {
    path: "bwa-reports",
    redirectTo: `${AppRoutes.reports}/${AppRoutes.bwaReport}/${AppRoutes.history}`,
    pathMatch: "full",
  },
  {
    path: "",
    redirectTo: `/${AppRoutes.home}`,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule {}
